<template>
  <div class="member-config-page">
    <div class="page-title">{{title}}</div>
    <div class='level-group'>
      <RadioGroup v-model="level">
          <Radio label= "0">普通会员</Radio>
          <Radio label= "1">初级会员</Radio>
          <Radio label= "2">中级会员</Radio>
          <Radio label= "3">高级会员</Radio>
          <Radio label= "4">SVIP会员</Radio>
      </RadioGroup>
    </div>
    <ul class='checkbox-area' v-loading='loading'>
      <div class='tips'>
        <div>仅配置未勾选的模块的url即可！</div><br>
        <div>因为未勾选的模块才是用户无权访问的模块</div>
      </div>
      <li v-for='(item, index) in data' :key='index'>
        <template>
            <span class='name'>{{item.name}}</span>
            <span class='line'></span>
            <div class='child'>
              <div v-for='subItem in item.child' :key='subItem.type_2' class='layer'>
                <Checkbox v-model="subItem.is_enable">{{subItem.type_2}}</Checkbox>
                <span class='upper' @click.stop='getUrl(subItem)'></span>
              </div>
            </div>
        </template>
      </li>
    </ul>
    <simpleDiag
      :isShow='dialogFlag'
      :title='dialogTitle'
      @close='close'
      @confirm='confirm'
    >
      <Input v-model="results" type="textarea" :rows="4" placeholder="请输入url..." />
      <div style='color: red;'>
        <div>单条url与备注间使用逗号，条数间使用回车</div>
        <div>格式: </div>
        <div>示例URL1,示例备注1</div>
        <div>示例URL2,示例备注2</div>
      </div>
    </simpleDiag>
  </div>
</template>
<script>
import simpleDiag from '@/components/dialogs/simpleDiag'
import { permissionList, memberPermissionUrl, memberEditUrl } from '@/api/member'
export default {
  name: 'memberConfig',
  components: { simpleDiag },
  data() {
    return {
      data: [],
      loading: false,
      title: '',
      level: '0', // 会员等级
      dialogFlag: false, // 弹框显示
      dialogTitle: '', // 弹框title
      results: '', // 弹框内容
      type1: '',
      type2: ''
    }
  },
  mounted() {
    this.initPage()
    this.getData()
  },
  watch: {
    level() {
      this.initPage()
      this.getData()
    }
  },
  methods: {
    initPage() {
      this.$store.dispatch('setPage', { title: '编辑', type: '' })
      this.title = '权限url配置'
      this.data = []
    },
    getData() {
      this.loading = true
      const tmpArr = []
      permissionList({ level: this.level }).then(res => {
        this.loading = false
        if (res.code === 0) {
          res.result.forEach(item => {
            if (item.length) {
              const obj = {}
              obj.name = item[0].type_1
              item.forEach(subItem => {
                if (subItem.is_enable === '0') {
                  subItem.is_enable = false
                } else {
                  subItem.is_enable = true
                }
              })
              obj.child = item
              tmpArr.push(obj)
            }
          })
          this.chuliData(tmpArr)
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.data = []
        }
      })
    },
    getUrl(item) {
      this.type1 = item.type_1
      this.type2 = item.type_2
      memberPermissionUrl({
        level: item.level,
        type_1: item.type_1,
        type_2: item.type_2
      }).then(res => {
        if (res.code === 0) {
          this.dialogFlag = true
          this.dialogTitle = item.type_2
          let str = ''
          if (res.result) {
            str = res.result.split('|').join('\n')
          }
          this.results = str
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    close() {
      this.dialogFlag = false
      this.results = ''
    },
    confirm() {
      let str = ''
      if (this.results) {
        str = this.results.replace(/，/g, ',').replace(/\n/g, '|').replace(/\s*/g, '')
      } else {
        str = this.results
      }
      memberEditUrl({
        level: this.level,
        type_1: this.type1,
        type_2: this.type2,
        urls: str
      }).then(res => {
        if (res.code === 0) {
          this.close()
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    chuliData(tmpArr) {
      const stand1 = ['工作台', '首页', '账户', '市场', '准入', '任务', '销售', '营销', '工作表', '数据源', '智能建表', '主数据库']
      const stand2 = [
        '中国基药数据库',
        '国产药品数据库',
        '进口药品数据库',
        '中国医保数据库',
        '生产企业数据库',
        '医生数据库',
        '中国医院数据库',
        '中国商业数据库',
        '中国药店数据库',
        '中国医疗机构库'
      ]
      stand1.forEach(item => {
        for (var i = 0; i < tmpArr.length; i++) {
          if (item === tmpArr[i].name) {
            if (item === '主数据库') {
              const tmp2 = []
              stand2.forEach(subItem => {
                for (var j = 0; j < tmpArr[i].child.length; j++) {
                  if (subItem === tmpArr[i].child[j].type_2) {
                    tmp2.push(tmpArr[i].child[j])
                    return false
                  }
                }
              })
              tmpArr[i].child = tmp2
            }
            this.data.push(tmpArr[i])
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .member-config-page {
    position: relative;
    .page-title {
      margin-top: 10px;
      color: #5D6F80;
      font-size: 16px;
      height: 16px;
      line-height: 16px;
      // font-family: PingFangSC-Semibold;
      font-weight: 600;
    }
    .tips {
      padding-left: 15px;
      color:red;
    }
    .level-group {
      position: absolute;
      right: 20px;
      top: 0px;
    }
    .checkbox-area {
      width: 100%;
      li {
        height: 50px;
        line-height: 50px;
        width: 100%;
        white-space: nowrap;
        .name {
          color: #5D6F80;
          font-weight: bold;
          display: inline-block;
          width: 50px;
          text-align: right;
          vertical-align: top;
        }
        .line {
          border-right:  1px solid #000000;
          margin: 0 30px;
          opacity: 0.1;
        }
        .child {
          width: calc( 100% - 111px);
          display: inline-block;
          white-space: pre-line;
          .layer {
            display: inline;
            position: relative;
            .ivu-checkbox-wrapper {
              min-width: 120px;
            }
            .upper {
              z-index: 2;
              position: absolute;
              display:inline-block;
              width: 130px;
              height: 20px;
              left: 0px;
              top: -2px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
